export enum MessageSortDirection {
    Oldest,
    Newest
}
